import { render } from "./VLotPositionItem.vue?vue&type=template&id=dfc44aec&scoped=true"
import script from "./VLotPositionItem.vue?vue&type=script&lang=js"
export * from "./VLotPositionItem.vue?vue&type=script&lang=js"

import "./VLotPositionItem.vue?vue&type=style&index=0&id=dfc44aec&scoped=true&lang=css"

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfc44aec"]])

export default __exports__